import React from "react";
import { Chip, type ChipProps } from "@mui/material";

type VideoProcessingChipProps = {
  label?: string;
  size?: ChipProps["size"];
  sx?: ChipProps["sx"];
};

/** Shown when a notice video is uploaded but not yet on `*-playback.mp4`. */
export const VideoProcessingChip: React.FC<VideoProcessingChipProps> = ({
  label = "Processing",
  size = "small",
  sx,
}) => (
  <Chip
    label={label}
    size={size}
    sx={{
      bgcolor: "info.main",
      color: "common.white",
      fontWeight: 600,
      fontSize: size === "small" ? 10 : 11,
      height: size === "small" ? 24 : 28,
      ...sx,
    }}
  />
);

export default VideoProcessingChip;
